import React from "react";
import { FaFacebook, FaTwitter, FaLinkedin } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="w-full bg-[#004c5f] text-white">
      <div className="container mx-auto p-8 ">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="font-bold mb-2">{t('footer.sites_heading')}</h3>
            <ul>
              <li><a href="https://sda-conseils.com" target="_blank" rel="noopener noreferrer" className="hover:underline">SDAConseils</a></li>
              <li><a href="https://exco-senegal.com" target="_blank" rel="noopener noreferrer" className="hover:underline">ExcoSenegal</a></li>
              <li><a href="https://www.kreston.com/" target="_blank" rel="noopener noreferrer" className="hover:underline">Kreston Global</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold mb-2">{t('footer.company_heading')}</h3>
            <ul>
              <li><a href="/about" className="hover:underline">{t('footer.about_us')}</a></li>
              <li><a href="/contact" className="hover:underline">{t('footer.contact_us')}</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold mb-2">{t('footer.apps_heading')}</h3>
            <div className="space-y-2">

            </div>
          </div>
        </div>

        <div className="mt-6 text-sm flex flex-col md:flex-row justify-between">
            <div className="flex justify-center space-x-4 mb-2">
                <a href="/" className="hover:underline">{t('footer.cgu')}</a>
                <a href="/" className="hover:underline">{t('footer.help_contact')}</a>
            </div>

            <div className="flex justify-center items-center space-x-4 text-lg mt-4 md:mt-0">
                <a href="/" className="hover:text-blue-500">{t('footer.by_yros')}</a>
                <a href="/" className="hover:text-black"><FaFacebook /></a>
                <a href="/" className="hover:text-black"><FaTwitter /></a>
                <a href="/" className="hover:text-black"><FaLinkedin /></a>
            </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
